export const isValidHex = (hex: string) =>
  /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/.test(hex);

// export const isValidHexWithoutHash = (hex: string) =>
//   /^([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/.test(hex);
export const isValidHexWithoutHash = (hex: string) =>
  /^([0-9A-Fa-f]{6})$/.test(hex);

export const removeInvalidHexCharacters = (hex: string) => {
  let cleanedHex = hex.replace(/[^0-9A-Fa-f]/g, ""); // Remove invalid hex characters
  return cleanedHex.length > 6 ? cleanedHex.slice(0, 6) : cleanedHex; // Trim if longer than 6 characters
};

export const convert3To6Hex = (hex: string) => {
  if (/^[0-9A-Fa-f]{3}$/.test(hex)) {
    return `${hex
      .split("")
      .map((char) => char + char) // Duplicate each character
      .join("")}`;
  }
  return hex;
};
